import { jsx as o, jsxs as l } from "react/jsx-runtime";
import { useState as c } from "react";
import { useTranslation as _, Drawer as p, Button as g, ButtonTypes as v, ButtonStyles as u, ButtonSize as k, ButtonWidth as f } from "@nextgen-web-framework/all";
import { useFormik as w, FormikProvider as h } from "formik";
import z from "./components/RegistrationUsername/RegistrationUsername.js";
import './assets/IdentityDrawer.css';const V = "#ffffff", m = "#396e75", C = "#e5fdff", b = "#546223", B = "#f0fae5", x = "#a65523", y = "#fff1e8", P = "#7f3e3e", O = "#ffe2e2", S = "#62625a", G = "#f8f8e7", I = "#38539a", R = "#707070", W = "#c8f8d1", D = "#87c9c8", T = "#5291b1", U = "rgba(82, 145, 177, 0.1019607843)", Y = "#445685", A = "#181d61", F = "rgba(24, 29, 97, 0.1019607843)", L = "#5969d6", j = "#ea999d", M = "#b6577e", N = "rgba(182, 87, 126, 0.1019607843)", E = "#7e3e80", q = "#1e247f", H = "rgba(30, 36, 127, 0.1019607843)", J = "#da7600", K = "#107f47", Q = "#d91734", X = "_html_4ovd0_46", Z = {
  amwayWhite: V,
  darkBlue: m,
  lightBlue: C,
  darkGreen: b,
  lightGreen: B,
  darkOrange: x,
  lightOrange: y,
  darkRed: P,
  lightRed: O,
  darkYellow: S,
  lightYellow: G,
  darkPurple: I,
  darkGrayOnWhite: R,
  dataVizColor1: W,
  dataVizColor2: D,
  dataVizColor3: T,
  dataVizColor3Background: U,
  dataVizColor4: Y,
  dataVizColor5: A,
  dataVizColor5Background: F,
  dataVizColor6: L,
  dataVizColor7: j,
  dataVizColor8: M,
  dataVizColor8Background: N,
  dataVizColor9: E,
  dataVizColor10: q,
  dataVizColor10Background: H,
  dataVizAlertOrange: J,
  dataVizSuccessGreen: K,
  dataVizWarningRed: Q,
  "no-visible": "_no-visible_4ovd0_42",
  html: X,
  "registration-personal-preview-wrapper": "_registration-personal-preview-wrapper_4ovd0_80",
  "registration-personal-preview-container": "_registration-personal-preview-container_4ovd0_92",
  "registration-personal-preview-heading": "_registration-personal-preview-heading_4ovd0_100",
  "registration-personal-preview-box": "_registration-personal-preview-box_4ovd0_113",
  "no-border": "_no-border_4ovd0_124",
  "registration-personal-preview-content-full": "_registration-personal-preview-content-full_4ovd0_128",
  "registration-personal-preview-content": "_registration-personal-preview-content_4ovd0_128",
  "info-title": "_info-title_4ovd0_140",
  "sponsor-detail-container": "_sponsor-detail-container_4ovd0_144",
  "image-container": "_image-container_4ovd0_170",
  "edit-personal-details": "_edit-personal-details_4ovd0_181",
  "tnc-checkbox-wrapper": "_tnc-checkbox-wrapper_4ovd0_196",
  "tnc-checkbox": "_tnc-checkbox_4ovd0_196",
  "tnc-text": "_tnc-text_4ovd0_204",
  "tnc-textlink": "_tnc-textlink_4ovd0_210",
  "tnc-textlink-checked": "_tnc-textlink-checked_4ovd0_217",
  "tnc-hyperlink": "_tnc-hyperlink_4ovd0_223",
  "submit-btn": "_submit-btn_4ovd0_230",
  "drawer-btn-container": "_drawer-btn-container_4ovd0_238",
  "desktop-image": "_desktop-image_4ovd0_244",
  "sponsor-personal-preview-box": "_sponsor-personal-preview-box_4ovd0_312",
  "skeleton-loading": "_skeleton-loading_4ovd0_1"
}, rt = ({
  setShowUsernameDrawer: i,
  nextHandlerFn: e
}) => {
  var r;
  const a = _(), [d, s] = c(), t = w({
    initialValues: { password: "", createPassword: "" },
    onSubmit: () => e(),
    initialStatus: { enableField: !0 }
  });
  return /* @__PURE__ */ o("div", { "data-testid": "field-input-container", "data-pod-name": "profile", children: /* @__PURE__ */ o(h, { value: t, children: /* @__PURE__ */ l(
    p,
    {
      header: a("profile.RegistrationPreview.createAmwayId"),
      closeIcon: !0,
      onClose: () => {
        i(!1);
      },
      bottomGap: 0,
      useReactPortal: !0,
      portalContainerId: "react-portal-drawer",
      children: [
        /* @__PURE__ */ o(
          z,
          {
            isPhonePrimaryContact: d,
            setIsPhonePrimaryContact: s,
            showSecondaryContactField: !1,
            isDrawerUsername: !0,
            nextHandler: e
          }
        ),
        /* @__PURE__ */ o("div", { className: Z["drawer-btn-container"], children: /* @__PURE__ */ o(
          g,
          {
            title: a("profile.common.nextButton"),
            type: v.BUTTON,
            "data-testid": "verification-btn-testid",
            "data-pod-name": "profile",
            buttonStyle: u.SOLID,
            size: k.MEDIUM,
            disabled: !((r = t.values) != null && r.password),
            buttonWidth: f.FULL_WIDTH,
            onClick: () => {
              var n;
              return e(((n = t == null ? void 0 : t.values) == null ? void 0 : n.createPassword) ?? "");
            }
          }
        ) })
      ]
    }
  ) }) });
};
export {
  rt as I,
  Z as s
};
//# sourceMappingURL=IdentityDrawer-2902dd81.mjs.map
